export default "__VITE_ASSET__06493b4b__"